import { LearnPageProgress } from '../../lib/LearnPageProgress/LearnPageProgress'
import cls from './LearnPageNavmenu.module.scss';
import {ButtonShare} from "../../../../shared/ui/ButtonShare/ButtonShare";
import {ButtonLike} from "../../../../shared/ui/ButtonLike/ButtonLike";
import logo from "../../../../logo.svg";
import React from 'react'
import {useNavigate} from "react-router-dom";

interface StudyDashboardNavMenuProps {
    studentCourse: any;
    studentId: string | undefined;
}

export const LearnPageNavmenu = ({studentCourse, studentId}: StudyDashboardNavMenuProps) => {
    const navigate = useNavigate();
    return (
        <div className={cls.studyDashboardNavMenu}>
            <img src={logo} className="logo" alt="logo" onClick={() => {
                navigate('/')
            }}/>

            <span className={cls.dividerVertical}/>

            <p>{studentCourse?.name}</p>
          
            <div className={cls.right}>
                <LearnPageProgress studentId={studentId}  totalLessons={studentCourse?.count_parts} currentStep={studentCourse?.count_completed_parts} totalSteps={studentCourse?.count_parts} />

                <div className={cls.buttons}>
                    <ButtonShare/>
                    <ButtonLike/>
                </div>
            </div>
        </div>
    );
}
